export default "__VITE_ASSET__DYwWxp5m__"